// extracted by mini-css-extract-plugin
export var wordContainer = "_q5-0";